import { useMutation, useQuery } from "@tanstack/react-query";
import client from "@/data/client";
import { enqueueSnackbar } from "notistack";
import { AxiosError } from "axios";
import { DefaultErrorResponse, QueryOptions } from "@/types";
import API_ENDPOINTS from "@/data/client/endpoints.ts";

export function useSetRecordingMutation() {
  return useMutation(client.agenda.setRecording, {
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(err.response?.data.message, {
        variant: "error",
      });
    },
  });
}

export function useUpsellingTracksMutation() {
  return useMutation(client.agenda.upsellingTracks, {
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(err.response?.data.message, {
        variant: "error",
      });
    }
  })
}

export function useGetRecording(id: number, options?: QueryOptions) {
  const { data, isLoading, error } = useQuery<{ link: string }, Error>(
    [API_ENDPOINTS.GET_RECORDING(id), id],
    () => client.agenda.getRecording(id),
    options,
  );
  return {
    recording: data,
    isLoading,
    error,
  };
}

export function useGetRecordingMutation() {
  return useMutation(client.agenda.getRecording, {
    onError: (error) => {
      const err = error as AxiosError<DefaultErrorResponse>;
      enqueueSnackbar(err.response?.data.message, {
        variant: "error",
      });
    },
  });
}
